import React from "react"

const FeatureTileGrid = ({
  title,
  description,
  children,
  alignLeft = false,
}) => {
  return (
    <section className={`container-fluid row ${alignLeft ? "" : "center-xs"}`}>
      <div className="col-xs-12 col-sm-8 col-md-6 mb-8">
        {title && <h2>{title}</h2>}
        {description && <p className="p--lg">{description}</p>}
      </div>
      <div className="col-xs-12 feature-tile-grid">{children}</div>
    </section>
  )
}

export default FeatureTileGrid
